import { useEffect } from "react";

export const useTitleChange = (title?: string) => {
  useEffect(() => {
    const nameTitle = title ? `${title} | ` : "";
    document.title = `${nameTitle}IPA`;
  }, []);
};
